<div class="tab-content business-settings" id="businessSettingPrint">
  <div
    *ngIf="noResponsibleCandidates"
    class="settings-empty-notice"
    role="status"
  >
    <i class="pi pi-info-circle" aria-hidden="true"></i>
    <div>
      <strong>{{ "BUSINESS_SETTINGS.NO_USERS_TITLE" | translate }}</strong>
      <p>{{ "BUSINESS_SETTINGS.NO_USERS_HINT" | translate }}</p>
    </div>
    <button
      *ngIf="canCreateSettingsPerson"
      pButton
      type="button"
      (click)="openPersonDialog(true)"
    >
      <i class="pi pi-plus" aria-hidden="true"></i>
      {{ "BUSINESS_SETTINGS.ADD_PERSON" | translate }}
    </button>
  </div>
  <p *ngIf="peopleRefreshFailed" class="text-danger" role="alert">
    {{ "BUSINESS_SETTINGS.REFRESH_FAILED" | translate }}
  </p>
  <div class="settings-sections" [attr.inert]="loading ? '' : null">
    <section class="settings-section" aria-labelledby="settings-DELEGATES">
      <header class="settings-section-heading">
        <div>
          <h2 id="settings-DELEGATES">
            {{ "BUSINESS_SETTINGS.DELEGATES" | translate }}
          </h2>
          <p>{{ "BUSINESS_SETTINGS.DELEGATES_HINT" | translate }}</p>
        </div>
        <span class="settings-section-number">{{
          "BUSINESS_SETTINGS.SECTION_NUMBER" | translate: { index: 1, total: 6 }
        }}</span>
      </header>
      <div class="settings-section-fields">
        <div class="row mb-2 align-items-center settings-employees-toggle">
          <div class="col-sm-7">
            <input type="hidden" pInputText [(ngModel)]="settingId" />
            <label class="kuba-choice-label"
              ><p-toggleswitch [(ngModel)]="emp.chkEmployee"></p-toggleswitch
              ><span>{{ "BUSINESS_SETTINGS.HAS_EMPLOYEES" | translate }}</span></label
            >
          </div>
        </div>
        <div class="row mb-2 align-items-center">
          <div class="col-sm-7">
            <label class="kuba-choice-label"
              ><p-toggleswitch
                [(ngModel)]="emp.chkMainSafetyDelegate"
              ></p-toggleswitch
              ><span>{{ "BUSINESS_SETTINGS.MAIN_SAFETY" | translate }}</span></label
            >
          </div>
          <div class="col-sm-5 settings-assignment-control">
            <div class="settings-assignment-value">
              <p-multiSelect
                [options]="OnlyEmployee"
                #mainSafetyDelegate="ngModel"
                [(ngModel)]="selectedMainSafetyDelegate"
                [required]="true"
                [style]="{ width: '100%' }"
                [disabled]="!emp.chkMainSafetyDelegate"
                [placeholder]="'SELECT' | translate"
              >
              </p-multiSelect>
            </div>
            <button
              *ngIf="canCreateSettingsPerson"
              pButton
              [outlined]="true"
              type="button"
              class="settings-add-person"
              (click)="openPersonDialog(false)"
              [attr.aria-label]="'BUSINESS_SETTINGS.ADD_PERSON' | translate"
              [pTooltip]="'BUSINESS_SETTINGS.ADD_PERSON' | translate"
            >
              <i class="pi pi-plus" aria-hidden="true"></i>
            </button>
          </div>
        </div>
        <div class="row mb-2 align-items-center">
          <div class="col-sm-7">
            <label class="kuba-choice-label"
              ><p-toggleswitch
                [(ngModel)]="emp.chkSafetyDelegate"
              ></p-toggleswitch
              ><span>{{ "BUSINESS_SETTINGS.SAFETY" | translate }}</span></label
            >
          </div>
          <div class="col-sm-5 settings-assignment-control">
            <div class="settings-assignment-value">
              <p-multiSelect
                [options]="OnlyEmployee | dropdownSelectTranslate"
                #safetyDelegate="ngModel"
                [(ngModel)]="selectedSafetyDelegate"
                [required]="true"
                [style]="{ width: '100%' }"
                [disabled]="!emp.chkSafetyDelegate"
                [placeholder]="'SELECT' | translate"
              ></p-multiSelect>
            </div>
            <button
              *ngIf="canCreateSettingsPerson"
              pButton
              [outlined]="true"
              type="button"
              class="settings-add-person"
              (click)="openPersonDialog(false)"
              [attr.aria-label]="'BUSINESS_SETTINGS.ADD_PERSON' | translate"
              [pTooltip]="'BUSINESS_SETTINGS.ADD_PERSON' | translate"
            >
              <i class="pi pi-plus" aria-hidden="true"></i>
            </button>
          </div>
        </div>
        <div class="row mb-2 align-items-center">
          <div class="col-sm-7">
            <label class="kuba-choice-label"
              ><p-toggleswitch
                [(ngModel)]="emp.chkEmployeeDelegate"
              ></p-toggleswitch
              ><span>{{ "BUSINESS_SETTINGS.EMPLOYEE_DELEGATES" | translate }}</span></label
            >
          </div>
          <div class="col-sm-5 settings-assignment-control">
            <div class="settings-assignment-value">
              <p-multiSelect
                [options]="OnlyEmployee | dropdownSelectTranslate"
                #employeeDelegate="ngModel"
                [(ngModel)]="selectedEmployeeDelegate"
                [required]="true"
                [style]="{ width: '100%' }"
                [disabled]="!emp.chkEmployeeDelegate"
                [placeholder]="'SELECT' | translate"
              ></p-multiSelect>
            </div>
            <button
              *ngIf="canCreateSettingsPerson"
              pButton
              [outlined]="true"
              type="button"
              class="settings-add-person"
              (click)="openPersonDialog(false)"
              [attr.aria-label]="'BUSINESS_SETTINGS.ADD_PERSON' | translate"
              [pTooltip]="'BUSINESS_SETTINGS.ADD_PERSON' | translate"
            >
              <i class="pi pi-plus" aria-hidden="true"></i>
            </button>
          </div>
        </div>
        <div class="row mb-2 align-items-center">
          <div class="col-sm-7">
            <label class="kuba-choice-label"
              ><p-toggleswitch
                [(ngModel)]="emp.chkFireDelegate"
              ></p-toggleswitch
              ><span>{{ "BUSINESS_SETTINGS.FIRE" | translate }}</span></label
            >
          </div>
          <div class="col-sm-5 settings-assignment-control">
            <div class="settings-assignment-value">
              <p-select
                [options]="OnlyEmployee | dropdownSelectTranslate"
                #fireDelegate="ngModel"
                [(ngModel)]="selectedFireDelegate"
                [required]="true"
                [style]="{ width: '100%' }"
                [disabled]="!emp.chkFireDelegate"
                placeholder="{{ 'SELECT' | translate }}"
              ></p-select>
            </div>
            <button
              *ngIf="canCreateSettingsPerson"
              pButton
              [outlined]="true"
              type="button"
              class="settings-add-person"
              (click)="openPersonDialog(false)"
              [attr.aria-label]="'BUSINESS_SETTINGS.ADD_PERSON' | translate"
              [pTooltip]="'BUSINESS_SETTINGS.ADD_PERSON' | translate"
            >
              <i class="pi pi-plus" aria-hidden="true"></i>
            </button>
          </div>
        </div>
        <div class="row mb-2 align-items-center">
          <div class="col-sm-7">
            <input type="hidden" pInputText [(ngModel)]="settingId" />
            <label class="kuba-choice-label"
              ><p-toggleswitch [(ngModel)]="emp.chkpersonal"></p-toggleswitch
              ><span>{{ "BUSINESS_SETTINGS.PERSONAL" | translate }}</span></label
            >
          </div>
          <div class="col-sm-5 settings-assignment-control">
            <div class="settings-assignment-value">
              <p-select
                [options]="
                  HavePersonalDelegateOptions | dropdownSelectTranslate
                "
                #personal="ngModel"
                [(ngModel)]="selectedPersonal"
                [required]="true"
                [style]="{ width: '100%' }"
                [disabled]="!emp.chkpersonal"
                placeholder="{{ 'SELECT' | translate }}"
              ></p-select>
            </div>
            <button
              *ngIf="canCreateSettingsPerson"
              pButton
              [outlined]="true"
              type="button"
              class="settings-add-person"
              (click)="openPersonDialog(true)"
              [attr.aria-label]="'BUSINESS_SETTINGS.ADD_PERSON' | translate"
              [pTooltip]="'BUSINESS_SETTINGS.ADD_PERSON' | translate"
            >
              <i class="pi pi-plus" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
    <section
      class="settings-section"
      aria-labelledby="settings-RESPONSIBILITIES"
    >
      <header class="settings-section-heading">
        <div>
          <h2 id="settings-RESPONSIBILITIES">
            {{ "BUSINESS_SETTINGS.RESPONSIBILITIES" | translate }}
          </h2>
          <p>{{ "BUSINESS_SETTINGS.RESPONSIBILITIES_HINT" | translate }}</p>
        </div>
        <span class="settings-section-number">{{
          "BUSINESS_SETTINGS.SECTION_NUMBER" | translate: { index: 2, total: 6 }
        }}</span>
      </header>
      <div class="settings-section-fields">
        <div class="row mb-2 align-items-center">
          <div class="col-sm-7">
            <label>
              <span translate>FLEXI_CUSTOMER_ACTION_POINT_RESPONSIBLE</span>
            </label>
          </div>
          <div class="col-sm-5 settings-assignment-control">
            <div class="settings-assignment-value">
              <p-multiSelect
                [options]="
                  CustomerActionPointResponsibleSelect | dropdownSelectTranslate
                "
                [(ngModel)]="selectedFlexiCustomerActionPointResponsibleUserIds"
                [style]="{ width: '100%' }"
                [filter]="true"
                [showClear]="true"
                [disabled]="
                  !canEditFlexiCustomerActionPointResponsible ||
                  (noCustomerActionPointResponsibleCandidates &&
                    !canCreateSettingsPerson)
                "
                [pTooltip]="
                  noCustomerActionPointResponsibleCandidates
                    ? ('RESPONSIBLE_TOOLTIP_CREATE_USERS' | translate)
                    : ('FLEXI_CUSTOMER_ACTION_POINT_RESPONSIBLE_HELP'
                      | translate)
                "
                tooltipPosition="top"
                placeholder="{{ 'SELECT' | translate }}"
              ></p-multiSelect>
            </div>
            <button
              *ngIf="canCreateSettingsPerson"
              type="button"
              pButton
              [outlined]="true"
              class="settings-add-person"
              (click)="openPersonDialog(true)"
              [attr.aria-label]="'BUSINESS_SETTINGS.ADD_PERSON' | translate"
              [pTooltip]="'BUSINESS_SETTINGS.ADD_PERSON' | translate"
            >
              <i class="pi pi-plus" aria-hidden="true"></i>
            </button>
          </div>
        </div>
        <div class="row mb-2 align-items-center settings-field-divider">
          <div class="col-sm-7">
            <label>
              <span translate>RESPONSIBLE_FOR_EXECUTION</span>
            </label>
          </div>
          <div class="col-sm-5 settings-assignment-control">
            <div class="settings-assignment-value">
              <p-multiSelect
                [options]="UsersByBusinessSelect | dropdownSelectTranslate"
                [(ngModel)]="selectedResponsibleForExecution"
                [style]="{ width: '100%' }"
                [filter]="true"
                [filterBy]="'label'"
                [showToggleAll]="false"
                [placeholder]="'SELECT' | translate"
                [panelStyle]="{ width: '100%' }"
                [disabled]="noResponsibleCandidates && !canCreateSettingsPerson"
                [pTooltip]="
                  noResponsibleCandidates
                    ? ('RESPONSIBLE_TOOLTIP_CREATE_USERS' | translate)
                    : null
                "
                tooltipPosition="top"
                [display]="'chip'"
              >
                <ng-template #footer
                  ><button
                    *ngIf="canCreateSettingsPerson"
                    pButton
                    [text]="true"
                    type="button"
                    class="settings-picker-add"
                    (click)="openPersonDialog(true)"
                  >
                    <i class="pi pi-plus" aria-hidden="true"></i>
                    {{ "BUSINESS_SETTINGS.ADD_PERSON" | translate }}
                  </button></ng-template
                ></p-multiSelect
              >
              <small
                class="text-muted"
                *ngIf="selectedResponsibleForExecution?.length"
              >
                {{
                  getSummary(
                    selectedResponsibleForExecution,
                    UsersByBusinessSelect
                  )
                }}
              </small>
            </div>
            <button
              *ngIf="canCreateSettingsPerson"
              type="button"
              pButton
              [outlined]="true"
              class="settings-add-person"
              (click)="openPersonDialog(true)"
              [attr.aria-label]="'BUSINESS_SETTINGS.ADD_PERSON' | translate"
              [pTooltip]="'BUSINESS_SETTINGS.ADD_PERSON' | translate"
            >
              <i class="pi pi-plus" aria-hidden="true"></i>
            </button>
          </div>
        </div>
        <div class="row mb-2 align-items-center">
          <div class="col-sm-7">
            <label>
              <span translate>RESPONSIBLE_FOR_FOLLOWUP</span>
            </label>
          </div>
          <div class="col-sm-5 settings-assignment-control">
            <div class="settings-assignment-value">
              <p-multiSelect
                [options]="UsersByBusinessSelect | dropdownSelectTranslate"
                [(ngModel)]="selectedResponsibleForFollowup"
                [style]="{ width: '100%' }"
                [filter]="true"
                [filterBy]="'label'"
                [display]="'chip'"
                [showToggleAll]="false"
                [placeholder]="'SELECT' | translate"
                [panelStyle]="{ width: '100%' }"
                [disabled]="noResponsibleCandidates && !canCreateSettingsPerson"
                [pTooltip]="
                  noResponsibleCandidates
                    ? ('RESPONSIBLE_TOOLTIP_CREATE_USERS' | translate)
                    : null
                "
                tooltipPosition="top"
              >
                <ng-template #footer
                  ><button
                    *ngIf="canCreateSettingsPerson"
                    pButton
                    [text]="true"
                    type="button"
                    class="settings-picker-add"
                    (click)="openPersonDialog(true)"
                  >
                    <i class="pi pi-plus" aria-hidden="true"></i>
                    {{ "BUSINESS_SETTINGS.ADD_PERSON" | translate }}
                  </button></ng-template
                ></p-multiSelect
              >
              <small
                class="text-muted"
                *ngIf="selectedResponsibleForFollowup?.length"
              >
                {{
                  getSummary(
                    selectedResponsibleForFollowup,
                    UsersByBusinessSelect
                  )
                }}
              </small>
            </div>
            <button
              *ngIf="canCreateSettingsPerson"
              type="button"
              pButton
              [outlined]="true"
              class="settings-add-person"
              (click)="openPersonDialog(true)"
              [attr.aria-label]="'BUSINESS_SETTINGS.ADD_PERSON' | translate"
              [pTooltip]="'BUSINESS_SETTINGS.ADD_PERSON' | translate"
            >
              <i class="pi pi-plus" aria-hidden="true"></i>
            </button>
          </div>
        </div>
        <div class="row mb-2 align-items-center" *ngIf="hasAppraisalModule">
          <div class="col-sm-7">
            <label>
              <span translate>RESPONSIBLE_FOR_APPRAISALS</span>
            </label>
          </div>
          <div class="col-sm-5 settings-assignment-control">
            <div class="settings-assignment-value">
              <p-multiSelect
                [options]="managerDropdown"
                [(ngModel)]="selectedResponsibleForAppraisals"
                [style]="{ width: '100%' }"
                [filter]="true"
                [filterBy]="'label'"
                [display]="'chip'"
                [showToggleAll]="false"
                [placeholder]="'SELECT' | translate"
                [panelStyle]="{ width: '100%' }"
                [disabled]="noResponsibleCandidates && !canCreateSettingsPerson"
                [pTooltip]="
                  noResponsibleCandidates
                    ? ('RESPONSIBLE_TOOLTIP_CREATE_USERS' | translate)
                    : null
                "
                tooltipPosition="top"
              >
                <ng-template #footer
                  ><button
                    *ngIf="canCreateSettingsPerson"
                    pButton
                    [text]="true"
                    type="button"
                    class="settings-picker-add"
                    (click)="openPersonDialog(true)"
                  >
                    <i class="pi pi-plus" aria-hidden="true"></i>
                    {{ "BUSINESS_SETTINGS.ADD_PERSON" | translate }}
                  </button></ng-template
                ></p-multiSelect
              >
              <small
                class="text-muted"
                *ngIf="selectedResponsibleForAppraisals?.length"
              >
                {{
                  getSummary(selectedResponsibleForAppraisals, managerDropdown)
                }}
              </small>
            </div>
            <button
              *ngIf="canCreateSettingsPerson"
              type="button"
              pButton
              [outlined]="true"
              class="settings-add-person"
              (click)="openPersonDialog(true)"
              [attr.aria-label]="'BUSINESS_SETTINGS.ADD_PERSON' | translate"
              [pTooltip]="'BUSINESS_SETTINGS.ADD_PERSON' | translate"
            >
              <i class="pi pi-plus" aria-hidden="true"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
    <section class="settings-section" aria-labelledby="settings-HSE">
      <header class="settings-section-heading">
        <div>
          <h2 id="settings-HSE">
            {{ "BUSINESS_SETTINGS.HSE" | translate }}
          </h2>
          <p>{{ "BUSINESS_SETTINGS.HSE_HINT" | translate }}</p>
        </div>
        <span class="settings-section-number">{{
          "BUSINESS_SETTINGS.SECTION_NUMBER" | translate: { index: 3, total: 6 }
        }}</span>
      </header>
      <div class="settings-section-fields">
        <div class="settings-hse-grid">
          <div class="settings-hse-field">
            <label for="settings-hse-manager">
              <span translate>HSE_RESPONSIBLE</span>
            </label>
            <div class="settings-assignment-control">
              <div class="settings-assignment-value">
                <p-select
                  inputId="settings-hse-manager"
                  [options]="HseManager | dropdownSelectTranslate"
                  [(ngModel)]="selectedHseManager"
                  [style]="{ width: '100%' }"
                  placeholder="{{ 'SELECT' | translate }}"
                ></p-select>
              </div>
            </div>
          </div>
          <div class="settings-hse-field">
            <label for="settings-environmental-lighthouse">
              <span translate>ENVIRONMENTAL_LIGHTHOUSE_RESPONSIBLE</span>
            </label>
            <div class="settings-assignment-control">
              <div class="settings-assignment-value">
                <p-select
                  inputId="settings-environmental-lighthouse"
                  [options]="EnvLight | dropdownSelectTranslate"
                  [(ngModel)]="selectedEnvLighthosue"
                  [style]="{ width: '100%' }"
                  placeholder="{{ 'SELECT' | translate }}"
                ></p-select>
              </div>
            </div>
          </div>
        </div>
        <!-- Read-only: advisors are managed in Admin mode › Flexi › Settings,
             so there is one place to change them. -->
        <div class="settings-hse-advisors">
          <span class="settings-hse-advisors__label" id="settings-hse-advisors-label">
            {{ "FLEXI_SETTINGS.TITLE" | translate }}
          </span>
          <div
            class="settings-hse-advisors__box"
            role="group"
            aria-labelledby="settings-hse-advisors-label"
          >
            <i
              class="pi pi-lock settings-hse-advisors__lock"
              role="img"
              [attr.aria-label]="'FLEXI_ADVISOR.READ_ONLY' | translate"
            ></i>
            <span
              *ngFor="let advisor of hseAdvisors"
              class="settings-hse-advisor"
              [class.settings-hse-advisor--primary]="advisor.IsPrimary"
              [class.settings-hse-advisor--inactive]="!advisor.IsEligible"
            >
              <span class="settings-hse-advisor__name">{{ advisor.Name }}</span>
              <span class="settings-hse-advisor__badge" *ngIf="advisor.IsPrimary">{{ "FLEXI_SETTINGS.PRIMARY" | translate }}</span>
              <span class="settings-hse-advisor__badge" *ngIf="!advisor.IsEligible">{{ "FLEXI_SETTINGS.INACTIVE" | translate }}</span>
            </span>
            <span class="settings-hse-advisors__empty" *ngIf="!hseAdvisors.length && !hseAdvisorsFailed">
              {{ "FLEXI_SETTINGS.NONE_ASSIGNED" | translate }}
            </span>
            <span class="settings-hse-advisors__empty" *ngIf="hseAdvisorsFailed">
              {{ "FLEXI_SETTINGS.LOAD_ADVISORS_FAILED" | translate }}
            </span>
          </div>
          <span class="settings-hse-advisors__hint" *ngIf="canManageHseAdvisors">
            {{ "FLEXI_SETTINGS.MANAGED_IN" | translate }}
            <a [routerLink]="flexiSettingsLink">{{ "FLEXI_SETTINGS.MANAGED_LINK" | translate }}</a>{{ "FLEXI_SETTINGS.MANAGED_SUFFIX" | translate }}
          </span>
        </div>
      </div>
    </section>
    <section class="settings-section" aria-labelledby="settings-INSURANCE">
      <header class="settings-section-heading">
        <div>
          <h2 id="settings-INSURANCE">
            {{ "BUSINESS_SETTINGS.INSURANCE" | translate }}
          </h2>
          <p>{{ "BUSINESS_SETTINGS.INSURANCE_HINT" | translate }}</p>
        </div>
        <span class="settings-section-number">{{
          "BUSINESS_SETTINGS.SECTION_NUMBER" | translate: { index: 4, total: 6 }
        }}</span>
      </header>
      <div class="settings-section-fields">
        <div class="row mb-2 align-items-center">
          <div class="col-sm-7">
            <label class="kuba-choice-label"
              ><p-toggleswitch
                [(ngModel)]="emp.chkAccountant"
                [disabled]="!canSelectExternalServicePerson"
              ></p-toggleswitch
              ><span>{{ "BUSINESS_SETTINGS.ACCOUNTANT" | translate }}</span></label
            >
          </div>
          <div class="col-sm-5 settings-assignment-control">
            <div class="settings-assignment-value">
              <p-select
                [options]="EmployeeContact | dropdownSelectTranslate"
                #accountant="ngModel"
                [(ngModel)]="selectedAccountant"
                [required]="true"
                [style]="{ width: '100%' }"
                [disabled]="!emp.chkAccountant || !canSelectExternalServicePerson"
                placeholder="{{ 'SELECT' | translate }}"
              ></p-select>
            </div>
            <button
              *ngIf="canCreateSettingsPerson"
              pButton
              [outlined]="true"
              type="button"
              class="settings-add-person"
              (click)="openPersonDialog(false)"
              [attr.aria-label]="'BUSINESS_SETTINGS.ADD_PERSON' | translate"
              [pTooltip]="'BUSINESS_SETTINGS.ADD_PERSON' | translate"
            >
              <i class="pi pi-plus" aria-hidden="true"></i>
            </button>
          </div>
        </div>
        <div class="row mb-2 align-items-center">
          <div class="col-sm-7">
            <label class="kuba-choice-label"
              ><p-toggleswitch
                [(ngModel)]="emp.chkAuditor"
                [disabled]="!canSelectExternalServicePerson"
              ></p-toggleswitch
              ><span>{{ "BUSINESS_SETTINGS.AUDITOR" | translate }}</span></label
            >
          </div>
          <div class="col-sm-5 settings-assignment-control">
            <div class="settings-assignment-value">
              <p-select
                [options]="EmployeeContact | dropdownSelectTranslate"
                #auditor="ngModel"
                [(ngModel)]="selectedAuditor"
                [required]="true"
                [style]="{ width: '100%' }"
                [disabled]="!emp.chkAuditor || !canSelectExternalServicePerson"
                placeholder="{{ 'SELECT' | translate }}"
              ></p-select>
            </div>
            <button
              *ngIf="canCreateSettingsPerson"
              pButton
              [outlined]="true"
              type="button"
              class="settings-add-person"
              (click)="openPersonDialog(false)"
              [attr.aria-label]="'BUSINESS_SETTINGS.ADD_PERSON' | translate"
              [pTooltip]="'BUSINESS_SETTINGS.ADD_PERSON' | translate"
            >
              <i class="pi pi-plus" aria-hidden="true"></i>
            </button>
          </div>
        </div>
        <div class="row mb-2 align-items-center">
          <div class="col-sm-7">
            <label class="kuba-choice-label"
              ><p-toggleswitch
                [(ngModel)]="emp.chkCompensationInsurance"
              ></p-toggleswitch
              ><span>{{ "BUSINESS_SETTINGS.WORKMEN" | translate }}</span></label
            >
          </div>
          <div class="col-sm-5">
            <input
              #employeeInsurance="ngModel"
              pInputText
              [(ngModel)]="selectedEmployeeInsurance"
              required
              [disabled]="!emp.chkCompensationInsurance"
            />
            <p *ngIf="!selectedEmpInsurance" style="color: red">
              * {{ "REQUIRED" | translate }}
            </p>
          </div>
        </div>
        <div class="row mb-2 align-items-center">
          <div class="col-sm-7">
            <label class="kuba-choice-label"
              ><p-toggleswitch
                [(ngModel)]="emp.chkStatutoryInsurance"
              ></p-toggleswitch
              ><span>{{ "BUSINESS_SETTINGS.OTP" | translate }}</span></label
            >
          </div>
          <div class="col-sm-5">
            <input
              #employee="ngModel"
              type="text"
              [(ngModel)]="selectedEmployee"
              required
              pInputText
              [disabled]="!emp.chkStatutoryInsurance"
            />
            <p *ngIf="!selectedEmpstatutory" style="color: red">
              * {{ "REQUIRED" | translate }}
            </p>
          </div>
        </div>
        <div class="row mb-2 align-items-center">
          <div class="col-sm-7">
            <input type="hidden" pInputText [(ngModel)]="settingId" />
            <label class="kuba-choice-label"
              ><p-toggleswitch
                [(ngModel)]="emp.chkOccupational"
              ></p-toggleswitch
              ><span>{{ "BUSINESS_SETTINGS.HEALTH" | translate }}</span></label
            >
          </div>
          <div class="col-sm-5">
            <input
              #occupational="ngModel"
              pInputText
              [(ngModel)]="selectedOccupational"
              required
              [disabled]="!emp.chkOccupational"
            />
            <p *ngIf="!selectedEmpOccupational" style="color: red">
              * {{ "REQUIRED" | translate }}
            </p>
          </div>
        </div>
        <div class="row mb-2 align-items-center">
          <div class="col-sm-7">
            <label for="InsuranceCompany">
              <span translate>INSURANCE_COMPANY</span>
            </label>
          </div>
          <div class="col-sm-5">
            <input
              type="text"
              [(ngModel)]="InsuranceCompany"
              pInputText
              [style]="{ width: '100%' }"
              maxlength="100"
            />
          </div>
        </div>
      </div>
    </section>
    <section class="settings-section" aria-labelledby="settings-ACCESS">
      <header class="settings-section-heading">
        <div>
          <h2 id="settings-ACCESS">
            {{ "BUSINESS_SETTINGS.ACCESS" | translate }}
          </h2>
          <p>{{ "BUSINESS_SETTINGS.ACCESS_HINT" | translate }}</p>
        </div>
        <span class="settings-section-number">{{
          "BUSINESS_SETTINGS.SECTION_NUMBER" | translate: { index: 5, total: 6 }
        }}</span>
      </header>
      <div class="settings-section-fields">
        <div
          class="row mb-2 align-items-center"
          *ngIf="showSdsExposureAccessSettings"
        >
          <div class="col-sm-7">
            <label>
              <span translate>SDS_EXPOSURE_EDITOR_ACCESS</span>
            </label>
            <small class="text-muted d-block" translate>
              SDS_EXPOSURE_EDITOR_ACCESS_HINT
            </small>
          </div>
          <div class="col-sm-5 settings-assignment-control">
            <div class="settings-assignment-value">
              <p-multiSelect
                [options]="sdsExposureEditorDropdown"
                [(ngModel)]="selectedSdsExposureEditorIds"
                [style]="{ width: '100%' }"
                [filter]="true"
                [filterBy]="'label'"
                [display]="'chip'"
                [showToggleAll]="false"
                [placeholder]="'SELECT' | translate"
                [panelStyle]="{ width: '100%' }"
                [disabled]="
                  isSdsExposureAccessLoading ||
                  (noSdsExposureEditorCandidates && !canCreateSettingsPerson)
                "
                [pTooltip]="
                  noSdsExposureEditorCandidates
                    ? ('SDS_EXPOSURE_EDITOR_ACCESS_NO_EDITORS' | translate)
                    : null
                "
                tooltipPosition="top"
              >
                <ng-template #footer
                  ><button
                    *ngIf="canCreateSettingsPerson"
                    pButton
                    [text]="true"
                    type="button"
                    class="settings-picker-add"
                    (click)="openPersonDialog(true)"
                  >
                    <i class="pi pi-plus" aria-hidden="true"></i>
                    {{ "BUSINESS_SETTINGS.ADD_PERSON" | translate }}
                  </button></ng-template
                ></p-multiSelect
              >
              <small
                class="text-muted"
                *ngIf="selectedSdsExposureEditorIds?.length"
              >
                {{
                  getSummary(
                    selectedSdsExposureEditorIds,
                    sdsExposureEditorDropdown
                  )
                }}
              </small>
              <small class="text-danger d-block" *ngIf="sdsExposureAccessError">
                {{ sdsExposureAccessError }}
              </small>
            </div>
            <button
              *ngIf="canCreateSettingsPerson"
              type="button"
              pButton
              [outlined]="true"
              class="settings-add-person"
              (click)="openPersonDialog(true)"
              [attr.aria-label]="'BUSINESS_SETTINGS.ADD_PERSON' | translate"
              [pTooltip]="'BUSINESS_SETTINGS.ADD_PERSON' | translate"
            >
              <i class="pi pi-plus" aria-hidden="true"></i>
            </button>
          </div>
        </div>
        <p *ngIf="!showSdsExposureAccessSettings" class="settings-field-hint">
          {{ "BUSINESS_SETTINGS.NO_ACCESS_MODULES" | translate }}
        </p>
      </div>
    </section>
    <section class="settings-section" aria-labelledby="settings-COMPANY">
      <header class="settings-section-heading">
        <div>
          <h2 id="settings-COMPANY">
            {{ "BUSINESS_SETTINGS.COMPANY" | translate }}
          </h2>
          <p>{{ "BUSINESS_SETTINGS.COMPANY_HINT" | translate }}</p>
        </div>
        <span class="settings-section-number">{{
          "BUSINESS_SETTINGS.SECTION_NUMBER" | translate: { index: 6, total: 6 }
        }}</span>
      </header>
      <div class="settings-section-fields">
        <div class="row mb-2 align-items-center" *ngIf="isShowBusinessLanguage">
          <div class="col-sm-7">
            <label for="BusinessLanguage">
              <span translate>BUSINESS_LANGUAGE</span>
            </label>
          </div>
          <div class="col-sm-5">
            <p-select
              [options]="Language | dropdownSelectTranslate"
              [(ngModel)]="selectedLanguage"
              [style]="{ width: '100%' }"
              placeholder="{{ 'SELECT' | translate }}"
            ></p-select>
          </div>
        </div>
        <div class="row mb-2 align-items-center">
          <div class="col-sm-7">
            <label for="HomePageAddress">
              <span translate>HOMEPAGE_ADDRESS</span>
            </label>
          </div>
          <div class="col-sm-5" *ngIf="siteAddress" [formGroup]="siteAddress">
            <input
              type="text"
              formControlName="homeSiteAddress"
              pInputText
              [style]="{ width: '100%' }"
            />
            <control-messages
              [control]="siteAddress.controls['homeSiteAddress']"
            ></control-messages>
          </div>
        </div>
        <div class="row mb-2 align-items-center business-settings-goals">
          <div class="col-sm-7">
            <label for="Goals">
              <span translate>HSE_GOALS</span>
            </label>
          </div>
          <div class="col-sm-5">
            <textarea
              pTextarea
              [(ngModel)]="HseGoals"
              maxlength="500"
              id="Goals"
              rows="4"
              [placeholder]="'BUSINESS_SETTINGS.GOALS_PLACEHOLDER' | translate"
            ></textarea
            ><small class="settings-field-hint">{{
              "BUSINESS_SETTINGS.GOALS_HINT" | translate
            }}</small>
          </div>
        </div>
        <div class="settings-upload-field">
          <label for="files">{{ "BUSINESS_LOGO" | translate }}</label>
          <div class="settings-upload-zone">
            <i *ngIf="!businessLogo" class="pi pi-image" aria-hidden="true"></i
            ><img
              *ngIf="businessLogo"
              [src]="businessLogo"
              alt=""
              class="settings-upload-preview"
            /><span class="settings-field-hint">{{
              "BUSINESS_SETTINGS.LOGO_HINT" | translate
            }}</span
            ><input
              #filesControl
              type="file"
              id="files"
              hidden
              accept="image/png,image/jpeg,image/gif"
              (change)="filesSelectForLogo($event)"
            /><button
              pButton
              [outlined]="true"
              type="button"
              (click)="filesControl.click()"
            >
              {{ "BUSINESS_SETTINGS.UPLOAD" | translate }}</button
            ><button
              *ngIf="businessLogo"
              pButton
              [text]="true"
              severity="danger"
              type="button"
              [attr.aria-label]="'DELETE' | translate"
              (click)="deleteImage('Business_Logo')"
            >
              <i class="pi pi-trash" aria-hidden="true"></i>
            </button>
          </div>
          <small *ngIf="uploadStartForLogo" role="status">{{
            "IMAGE_IS_UPLOADING" | translate
          }}</small>
        </div>
        <div class="settings-upload-field">
          <label for="businessfiles">{{ "BUSINESS_IMAGE" | translate }}</label>
          <div class="settings-upload-zone">
            <i *ngIf="!businessImage" class="pi pi-image" aria-hidden="true"></i
            ><img
              *ngIf="businessImage"
              [src]="businessImage"
              alt=""
              class="settings-upload-preview"
            /><span class="settings-field-hint">{{
              "BUSINESS_SETTINGS.IMAGE_HINT" | translate
            }}</span
            ><input
              #businessfilesControl
              type="file"
              id="businessfiles"
              hidden
              accept="image/png,image/jpeg,image/gif"
              (change)="filesSelect($event)"
            /><button
              pButton
              [outlined]="true"
              type="button"
              (click)="businessfilesControl.click()"
            >
              {{ "BUSINESS_SETTINGS.UPLOAD" | translate }}</button
            ><button
              *ngIf="businessImage"
              pButton
              [text]="true"
              severity="danger"
              type="button"
              [attr.aria-label]="'DELETE' | translate"
              (click)="deleteImage('Business_Image')"
            >
              <i class="pi pi-trash" aria-hidden="true"></i>
            </button>
          </div>
          <small *ngIf="uploadStart" role="status">{{
            "IMAGE_IS_UPLOADING" | translate
          }}</small>
        </div>
      </div>
    </section>
  </div>
  <div class="action-btns-wrapper">
    <div class="row">
      <div class="col-sm-6">
        <button
          pButton
          type="submit"
          (click)="saveChanges()"
          [ngClass]="{ loading: loading }"
          [disabled]="
            mainSafetyDelegate.invalid ||
            safetyDelegate.invalid ||
            employeeDelegate.invalid ||
            fireDelegate.invalid ||
            accountant.invalid ||
            auditor.invalid ||
            accountant.invalid ||
            loading ||
            isSdsExposureAccessLoading
          "
        >
          <span *ngIf="!loading" translate>SAVE</span>
          <span *ngIf="loading" translate>SAVE_PROCESS</span>
          <span *ngIf="loading" class="loader-icon"></span>
        </button>

        <button
          *ngIf="!isDinHMSLogin"
          pButton
          [outlined]="true"
          [routerLink]="['../features']"
          [disabled]="
            mainSafetyDelegate.invalid ||
            safetyDelegate.invalid ||
            employeeDelegate.invalid ||
            fireDelegate.invalid ||
            accountant.invalid ||
            employee.invalid ||
            employeeInsurance.invalid ||
            auditor.invalid ||
            accountant.invalid ||
            loading ||
            isSdsExposureAccessLoading
          "
          (click)="saveChanges()"
        >
          <span translate>SAVE_AND_NEXT</span>
        </button>
        <span
          *ngIf="hasUnsavedSettings"
          class="settings-save-state"
          role="status"
          >{{ "BUSINESS_SETTINGS.UNSAVED" | translate }}</span
        >
      </div>
      <div class="col-sm-6 text-right settings-secondary-actions">
        <button
          *ngIf="canCreateSettingsPerson"
          pButton
          [text]="true"
          type="button"
          [disabled]="refreshingPeople"
          (click)="refreshPeopleOptions()"
          [attr.aria-label]="'BUSINESS_SETTINGS.REFRESH_PEOPLE' | translate"
          [pTooltip]="'BUSINESS_SETTINGS.REFRESH_PEOPLE' | translate"
        >
          <i class="pi pi-refresh" aria-hidden="true"></i>
        </button>
        <button
          type="button"
          pButton
          [outlined]="true"
          *ngIf="isEditBusiness"
          (click)="exportallPdf()"
        >
          <i class="pi pi-print"></i>
          <span translate>PRINT_ALL</span>
        </button>
        <button
          type="button"
          pButton
          [outlined]="true"
          *ngIf="isEditBusiness"
          (click)="exportPdf()"
        >
          <i class="pi pi-print"></i>
          <span translate>PRINT_PAGE</span>
        </button>
      </div>
    </div>
  </div>
  <p-confirmDialog
    header="{{ 'CONFIRMATION' | translate }}"
    icon="pi pi-question-circle"
    width="425"
    acceptLabel="{{ 'SWITCH_YES' | translate }}"
    rejectLabel="{{ 'SWITCH_NO' | translate }}"
  ></p-confirmDialog>
  <business-settings-person-dialog
    *ngIf="showPersonDialog"
    [businessId]="businessId"
    [applicationId]="settingsApplicationId"
    [businessName]="settingsBusinessName"
    [withLogin]="createPersonWithLogin"
    (closed)="showPersonDialog = false"
    (changed)="refreshPeopleOptions()"
  />
</div>
